import {
  DurationPickerV2,
  InfoIconPopover,
  InfoPopover,
  Typography,
} from '@automata/ui';
import type { TimeBreakdownStrings } from '@automata/ui/src/DurationPickerV2/types';
import { Box, Slider, Stack } from '@mui/material';
import { FC } from 'react';

export type Props = {
  idealBreakdown: TimeBreakdownStrings;
  priorityWeight: number;
  setPriorityWeight: (weight: number) => void;
  onIdealBlur: () => void;
  onIdealUpdate: (patch: Partial<TimeBreakdownStrings>) => void;
};

export const TimingTargetParams: FC<Props> = ({
  idealBreakdown,
  priorityWeight,
  setPriorityWeight,
  onIdealBlur,
  onIdealUpdate,
}: Props) => {
  return (
    <>
      <Stack spacing={1}>
        <Stack direction="row" spacing={2}>
          <Stack flex={1}>
            <DurationPickerV2
              label="IDEAL TIME"
              hours={idealBreakdown.hours}
              minutes={idealBreakdown.minutes}
              seconds={idealBreakdown.seconds}
              handleBlurParent={onIdealBlur}
              handleUpdateTime={onIdealUpdate}
            />
          </Stack>
        </Stack>
      </Stack>
      <Stack spacing={1}>
        <Box display="flex" flexDirection="row" gap={1} alignItems="center">
          <Typography variant="overline">Priority</Typography>
          <InfoIconPopover
            infoPopover={
              <InfoPopover
                title="Priority"
                copy={
                  <div>
                    Adds a weight to a timing target. During planning, a rule
                    with higher priority takes precedence over one with lower
                    priority.
                  </div>
                }
              />
            }
          />
        </Box>
        <Slider
          value={priorityWeight}
          min={1}
          max={10}
          step={1}
          valueLabelDisplay="auto"
          onChange={(_, v) => setPriorityWeight(v as number)}
        />
        <Box display="flex" justifyContent="space-between">
          <Typography variant="caption">1</Typography>
          <Typography variant="caption">10</Typography>
        </Box>
      </Stack>
    </>
  );
};
